import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import React from 'react';
import './FactorTipsOffersModule.scss';
import CreditRepairOfferRedesign from 'components/Offers/CreditRepairRedesign/CreditRepairOfferRedesign';
import classnames from 'classnames';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';
import OText from 'components/CText/OText';
import StandardRedesignMarketplaceCreditCardOfferSwitch from 'components/Offers/StandardRedesignMarketplaceCreditCardOfferSwitch/StandardRedesignMarketplaceCreditCardOfferSwitch';
import { getOldestAccount } from 'helpers/dateHelper';

const ShowTips = ({ tips = [], hasOffers, creditCardDebt }) => {
  const oldestAccountName = getOldestAccount(creditCardDebt)?.name;

  return tips?.map((tip, index) => {
    if (tip?.hideIfNoOffers && !hasOffers) return null;

    let bodyText = tip?.body;
    if (bodyText?.includes('#oldestAccountName') && bodyText?.replace) {
      bodyText = bodyText.replace('#oldestAccountName', oldestAccountName);
    }

    const borderGrayClass = classnames('borderTpGray025', {
      poof: index === tips.length - 1,
    });
    return (
      <>
        <FlexContainer key={'offersTips' + index} className={'flex-column'}>
          <Label className={'subTitle1'}>{tip.headline}</Label>
          <Label className={'Body2'}>
            <OText text={bodyText} />
          </Label>
        </FlexContainer>
        <FlexContainer className={borderGrayClass} />
      </>
    );
  });
};

const FactorTipsOffersModuleView = props => {
  const {
    offers,
    eventHandler,
    tips,
    seenPixel,
    modulePosition,
    pagePosition,
    creditCardDebt,
  } = props;

  if (offers?.length > 0 || tips?.length > 0) {
    return (
      <FlexContainer className="margT28  flex-column">
        {seenPixel}
        <FlexContainer
          className={'bgNeutral005 margt20'}
          style={{ height: '20px' }}
        />
        {offers?.length > 0 && (
          <Disclaimer
            showPartnerText
            datatestid="PaymentHistoryOffersModuleView"
            className={'padLR24 m-padLR16 padt16'}
          />
        )}
        <FlexContainer
          className={'padLR48 m-padLR16 flex-column margT20 m-margT20'}
        >
          {tips?.length > 0 && (
            <FlexContainer className="tips system_info_i025 borderRadius16 margB12 items-align-center justify-center">
              <Label className="label caption">TIPS</Label>
            </FlexContainer>
          )}
          <FlexContainer className={'flex-column gap-12'}>
            {tips?.length > 0 && (
              <ShowTips
                tips={tips}
                hasOffers={offers?.length > 0}
                creditCardDebt={creditCardDebt?.accounts}
              />
            )}
            {offers?.length > 0 && (
              <FlexContainer>
                <StaticOfferContainer
                  offerMetadataList={[offers[0]]}
                  creditRepairOfferTemplate={CreditRepairOfferRedesign}
                  eventHandler={eventHandler}
                  pagePosition={pagePosition}
                  modulePosition={modulePosition}
                  creditCardTemplate={
                    StandardRedesignMarketplaceCreditCardOfferSwitch
                  }
                />
              </FlexContainer>
            )}
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    );
  } else {
    return null;
  }
};

export default FactorTipsOffersModuleView;
